import React from 'react';
import { Typography, Grid, Box, Avatar, Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  accordionHeading: {
    fontSize: "18px",
    fontWeight: "500",
  },
}));


const OTPIntegration = () => {
    const classes = useStyles();
        
    return (
      <React.Fragment>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                  >
                    <Typography className={classes.accordionHeading}>
                      <ul className="mb-0">
                        <li>
                          Prasyarat
                        </li>
                      </ul>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography className="pl-25">
                      <ul className="mb-0">
                        <li>Anda harus menginstall <u><a className='text-black' href="https://quickey-docs.netlify.app/">QuicKey SDK</a></u> ke dalam aplikasi web/mobile Anda</li>
                      </ul>
                    </Typography>
                  </AccordionDetails>
                </Accordion>
                
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                  >
                    <Typography className={classes.accordionHeading}>
                      <ul className="mb-0">
                        <li>
                          Pengaturan Layanan
                        </li>
                      </ul>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography className="pl-25">
                      Setelah menginstall ekstensi Quickey, anda sekarang dapat mengaktifkan SMS/Whatsapp OTP Login ke dalam aplikasi anda dengan catatan anda menghubungi pihak pengembang Quickey terlebih dahulu.
                    </Typography>
                  </AccordionDetails>
                </Accordion>
    </React.Fragment>
  )
}

export default OTPIntegration
